// Adapted from davinci-elections apps/web/src/theme/recipes/badge.ts @ 6e23f58
import { defineRecipe } from '@chakra-ui/react'

const xs = {
  fontSize: 'xs',
  lineHeight: 'xs',
  px: 1,
  py: 0.5,
}

const sm = {
  fontSize: 'sm',
  lineHeight: 'sm',
  px: 2,
  py: 1,
}

const md = {
  fontSize: 'md',
  lineHeight: 'md',
  px: 3,
  py: 2,
}

const lg = {
  fontSize: 'lg',
  lineHeight: 'lg',
  px: 3,
  py: 2,
}

/**
 * Status badges (R113): the subtle tint gets a hairline ring of the palette's muted step, so a gray "Not active" badge
 * still reads as a badge on a white card and two tints side by side stay apart.
 */
const subtle = {
  shadow: 'inset 0 0 0px 1px var(--shadow-color)',
  shadowColor: 'colorPalette.muted',
}

export const Badge = defineRecipe({
  variants: {
    size: { xs, sm, md, lg },
    variant: { subtle },
  },
  defaultVariants: { size: 'xs', variant: 'subtle' },
})
